import { ReadShiftReportDepartmentEntry } from "@/types/shiftReportDepartmentEntry";
import { createColumnHelper } from "@tanstack/react-table";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import ShiftReportEditorEntryWarning from "../components/ShiftReportEditorEntryWarning";
import ShiftReportEntryCellInputNumber from "../components/ShiftReportEntryCellInputNumber";
import ShiftReportEntryCellInputName from "../components/ShiftReportEntryCellIName";

export const useShiftReportEntryColumns = () => {
  const { t } = useTranslation();
  const columnHelper = createColumnHelper<ReadShiftReportDepartmentEntry>();

  const columns = useMemo(
    () => [
      columnHelper.accessor("department_name", {
        header: t("shiftReports.entry.department"),
        cell: (cell) => <ShiftReportEntryCellInputName cell={cell} />,
        meta: {
          className: "col-span-4 lg:col-span-5",
        },
      }),
      columnHelper.accessor("ordered", {
        header: t("shiftReports.entry.ordered"),
        cell: (cell) => (
          <ShiftReportEntryCellInputNumber row={cell.row} name="ordered" />
        ),
        meta: {
          className: "col-span-3 lg:col-span-2",
        },
      }),
      columnHelper.accessor("present", {
        header: t("shiftReports.entry.present"),
        cell: (cell) => (
          <ShiftReportEntryCellInputNumber row={cell.row} name="present" />
        ),
        meta: {
          className: "col-span-3 lg:col-span-2",
        },
      }),
      columnHelper.display({
        id: "warning",
        header: () => null,
        enableSorting: false,
        cell: (cell) => {
          return <ShiftReportEditorEntryWarning row={cell.row} />;
        },
        meta: {
          className: "col-span-2 lg:col-span-3",
        },
      }),
    ],
    [columnHelper, t],
  );

  return columns;
};
